import { render, staticRenderFns } from "./EditCoupons.vue?vue&type=template&id=3006f995&"
import script from "./EditCoupons.vue?vue&type=script&lang=js&"
export * from "./EditCoupons.vue?vue&type=script&lang=js&"
import style0 from "./EditCoupons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports